import React from "react";

const About = () => {
  return (
    <div className="page active">
      <h2 className="page-title">About Us</h2>
      <div className="about-content">
        <div className="about-text">
          <h3>Our Story</h3>
          <p>
            Established in the year 2000, Devanshi Corporation has emerged as a
            leading importer and supplier of industrial chemicals, and specialty
            products. Based in Mumbai, Maharashtra, we have built a strong
            reputation for quality, reliability, and customer satisfaction over
            more than two decades.
          </p>

          <h3 style={{ marginTop: "0.5rem" }}>Our Mission</h3>
          <p>
            To be the preferred partner for businesses seeking high-quality
            industrial chemicals, providing innovative solutions that drive
            growth and success across various industries.
          </p>

          <h3 style={{ marginTop: "0.5rem" }}>Why Choose Us?</h3>
          <ul style={{ paddingLeft: "0rem", listStyleType: "none" }}>
            <li>✅ &nbsp;25+ Years of Industry Experience</li>
            <li>✅ &nbsp;Wide Range of Quality Products</li>
            <li>✅ &nbsp;Competitive Pricing</li>
            <li>✅ &nbsp;Timely Delivery</li>
            <li>✅ &nbsp;Excellent Customer Support</li>
          </ul>
        </div>

        <div className="about-text">
          <h3>Company Information</h3>
          <div style={{ marginTop: "1rem" }}>
            <p>
              <strong>CEO:</strong> Paras Pandya
            </p>
            <p>
              <strong>Year Established:</strong> 2000
            </p>
            <p>
              <strong>Legal Status:</strong> Proprietorship
            </p>
            <p>
              <strong>GST Number:</strong> 27AAEHP0870M1ZU
            </p>
            <p>
              <strong>Annual Turnover:</strong> ₹15-20 Crore
            </p>
            <p>
              <strong>Nature of Business:</strong> Importer -
              Wholesaler/Distributor
            </p>
          </div>

          <h3 style={{ marginTop: "2rem" }}>Our Services</h3>
          <ul style={{ marginTop: "1rem", paddingLeft: "1.5rem" }}>
            <li>Import & Export of Industrial Chemicals</li>
            <li>Wholesale Distribution</li>
            <li>Custom Procurement Solutions</li>
            <li>Quality Testing & Certification</li>
            <li>Logistics & Supply Chain Management</li>
          </ul>
        </div>
      </div>

      <div className="company-stats">
        <div className="stat-item">
          <div className="stat-number">25+</div>
          <div className="stat-label">Years of Experience</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">500+</div>
          <div className="stat-label">Satisfied Clients</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">50+</div>
          <div className="stat-label">Product Categories</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">20Cr</div>
          <div className="stat-label">Annual Turnover</div>
        </div>
      </div>
    </div>
  );
};

export default About;
